/* mc-collection.js — keep the customer's two choices from erasing each
   other.

   Sorting dropped the active price band and filtering dropped the active
   sort. Verified on the live shop: with filter.v.price.gte=85 applied,
   every sort link read ?sort_by=… and nothing else.

   The Liquid tries to do this and cannot. It reads the applied range off
   collection.filters, and Shopify only populates min_value/max_value
   there when the price filter is enabled in Search & Discovery. It is
   not, so the loop never runs, price_qs stays empty, and the links look
   right in the source while carrying nothing. An earlier attempt used
   request.url, which does not exist at all — same silent blank.

   The URL is the one place the truth always is, so this reads it there.
   Liquid has no access to the query string; JavaScript does. */
(function () {
  'use strict';

  var here = new URLSearchParams(location.search);
  if (!here.toString()) return;

  /* Only these travel. Everything else in the URL — cache busters,
     utm_*, whatever an advert appended — is noise that was being copied
     into every link on the page. */
  function carries(k) {
    return k === 'sort_by' || k.indexOf('filter.') === 0;
  }

  /* Snapshot BOTH sets before rewriting either.

     The first version rewrote the sort links, which gave them
     filter.v.price in their href — and the price selector then matched
     those same links and merged again. "Sve cijene" came out still
     carrying the band it was supposed to clear. Two passes over a list
     the first pass had already changed. */
  /* Which menu a link is in, not what its href happens to contain.

     Liquid puts sort_qs on the price links and price_qs on the sort
     links — that is the whole point of them — so deciding membership
     from the href put every link in both sets. "Do 70 KM" came out
     carrying gte=85 as well, and "Sve cijene" kept the band it exists
     to clear. The markup knows; ask it. */
  var sortLinks  = [].slice.call(document.querySelectorAll('[data-mc-menu="sort"] a[href]'));
  var priceLinks = [].slice.call(document.querySelectorAll('[data-mc-menu="price"] a[href]'))
    .filter(function (a) { return !a.hasAttribute('data-mc-price-reset'); });
  var pagerLinks = [].slice.call(document.querySelectorAll('.bh-pager a[href]'));

  /* The reset is shaped exactly like a sort link and must not be merged
     into: it has to arrive with the bands gone. Left untouched. */

  function merge(link, owns) {
    var url;
    try { url = new URL(link.getAttribute('href'), location.origin); }
    catch (e) { return; }
    here.forEach(function (v, k) {
      if (!carries(k)) return;
      /* What the link is FOR wins; the rest is carried across. */
      if (owns.some(function (p) { return k === p || k.indexOf(p) === 0; })) return;
      if (!url.searchParams.has(k)) url.searchParams.set(k, v);
    });
    link.setAttribute('href', url.pathname + (url.search || ''));
  }

  sortLinks.forEach(function (a) { merge(a, ['sort_by']); });
  priceLinks.forEach(function (a) { merge(a, ['filter.']); });
  pagerLinks.forEach(function (a) { merge(a, ['page']); });

  /* "Sve cijene" sets no filter of its own, so it is in neither set and
     nothing above touches it — which is correct. It must arrive with the
     bands cleared, and it does: it keeps only the sort Liquid gave it. */
})();

/* ── The filter drawer ──────────────────────────────────────

   The sidebar stood open beside every collection, 262px of checkboxes
   nobody asked for, and it pushed the grid to three columns where four
   fit. Now it opens on request.

   Progressive, in the theme's usual order: the markup renders the
   sidebar exactly as before, and only this script turns it into a
   drawer — by putting .mc-fdrawer on <html> and unhiding the button.
   Blocked, the customer gets the old always-open sidebar, which works.
   Never a button that opens nothing. */
(function () {
  'use strict';

  var wrap = document.querySelector('[data-mc-filters]');
  var btn  = document.querySelector('[data-mc-filters-open]');
  if (!wrap || !btn) return;

  document.documentElement.classList.add('mc-fdrawer');
  btn.hidden = false;

  /* How many filters are actually on. Read from the URL rather than the
     markup: the price bands and the sale flag are Shopify's own
     filter.* params, and the category is the collection you are in —
     which the button cannot see from a checkbox that is only styled. */
  (function () {
    var n = 0;
    var q = location.search.slice(1).split('&');
    for (var i = 0; i < q.length; i++) {
      if (q[i].indexOf('filter.') === 0) n++;
    }
    var badge = btn.querySelector('[data-mc-filters-count]');
    if (badge && n > 0) { badge.textContent = String(n); badge.hidden = false; }
  })();

  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    wrap.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    var first = wrap.querySelector('a, button');
    if (first && first.focus) first.focus({ preventScroll: true });
  }

  function close() {
    if (!wrap.hasAttribute('data-open')) return;
    wrap.removeAttribute('data-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  btn.addEventListener('click', open);

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-mc-filters-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
